export default "__VITE_ASSET__Dyql2sPD__"